/* =========================================
   LUXURY FAQ PRO - JEWELITE
========================================= */

document.addEventListener('DOMContentLoaded', () => {

  /* =========================================
     ACCORDION
  ========================================= */

  const faqSections = document.querySelectorAll('.jl-faq');

  faqSections.forEach(section => {

    const items = section.querySelectorAll('.jl-faq__item');

    items.forEach(item => {

      const trigger = item.querySelector('.jl-faq__trigger');

      if (!trigger) return;

      trigger.addEventListener('click', () => {

        const isActive = item.classList.contains('active');

        // Close all items first
        items.forEach(faq => {
          faq.classList.remove('active');

          const btn = faq.querySelector('.jl-faq__trigger');
          if (btn) {
            btn.setAttribute('aria-expanded', 'false');
          }
        });

        // Open clicked item
        if (!isActive) {
          item.classList.add('active');

          trigger.setAttribute('aria-expanded', 'true');
        }

      });

    });

  });

  /* =========================================
     SEARCH FILTER
  ========================================= */

  const searchInputs = document.querySelectorAll('.jl-faq-search');

  searchInputs.forEach(input => {

    input.addEventListener('input', function () {

      const searchValue = this.value.toLowerCase();

      const faqSection = this.closest('.jl-faq');

      const items = faqSection.querySelectorAll('.jl-faq__item');

      items.forEach(item => {

        const question =
          item.querySelector('.jl-faq__question')?.textContent.toLowerCase() || '';

        const answer =
          item.querySelector('.jl-faq__answer')?.textContent.toLowerCase() || '';

        const match =
          question.includes(searchValue) ||
          answer.includes(searchValue);

        item.style.display = match ? '' : 'none';

      });

    });

  });

  /* =========================================
     CATEGORY FILTER
  ========================================= */

  const categoryButtons = document.querySelectorAll('.jl-faq__cat');

  categoryButtons.forEach(button => {

    button.addEventListener('click', function () {

      const faqSection = this.closest('.jl-faq');

      const buttons = faqSection.querySelectorAll('.jl-faq__cat');
      const items = faqSection.querySelectorAll('.jl-faq__item');

      buttons.forEach(btn => btn.classList.remove('active'));

      this.classList.add('active');

      const selectedCategory = this.dataset.category;

      items.forEach(item => {

        const itemCategory = item.dataset.category;

        if (
          selectedCategory === 'all' ||
          itemCategory === selectedCategory
        ) {
          item.style.display = '';
        } else {
          item.style.display = 'none';
        }

      });

    });

  });

  /* =========================================
     OPEN FIRST FAQ (OPTIONAL)
  ========================================= */

  document.querySelectorAll('.jl-faq').forEach(section => {

    const firstItem = section.querySelector('.jl-faq__item');

    if (
      firstItem &&
      section.dataset.openFirst === 'true'
    ) {
      firstItem.classList.add('active');

      const trigger = firstItem.querySelector('.jl-faq__trigger');

      if (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      }
    }

  });

  /* =========================================
     SMOOTH SCROLL TO OPEN ITEM
  ========================================= */

  document.querySelectorAll('.jl-faq__trigger').forEach(trigger => {

    trigger.addEventListener('click', () => {

      setTimeout(() => {

        const activeItem = trigger.closest('.jl-faq__item');

        if (
          activeItem &&
          activeItem.classList.contains('active')
        ) {

          activeItem.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });

        }

      }, 250);

    });

  });

  /* =========================================
     ACCESSIBILITY
  ========================================= */

  document.querySelectorAll('.jl-faq__trigger').forEach(trigger => {

    trigger.addEventListener('keydown', function (e) {

      if (
        e.key === 'Enter' ||
        e.key === ' '
      ) {

        e.preventDefault();
        this.click();

      }

    });

  });

});